import { useValidateDealSelectionMutation } from '@/lib/graphql/generated/graphql';
import { trackEvent } from '@/lib/mixpanel';
import { dealRefetchAtom } from '@/states/deal.state';
import { useAtomValue } from 'jotai';

export const useValidateDealSelection = (dealId: string) => {
  const dealRefetch = useAtomValue(dealRefetchAtom);
  const [validateDealSelectionMutation, { loading, error }] =
    useValidateDealSelectionMutation();

  const validateDealSelection = async () => {
    trackEvent('DEAL_VALIDATION_STARTED', { dealId });
    try {
      const result = await validateDealSelectionMutation({
        variables: { dealId },
      });
      const response = result.data?.validateDealSelection;
      if (response?.__typename === 'DomainException') {
        trackEvent('DEAL_VALIDATION_FAILED', {
          dealId,
          errorCode: response.code,
        });
      } else {
        trackEvent('DEAL_VALIDATION_SUCCEEDED', { dealId });
      }
      await dealRefetch.fn();
      return result;
    } catch (err) {
      trackEvent('DEAL_VALIDATION_FAILED', {
        dealId,
        errorCode: err instanceof Error ? err.message : 'unknown_error',
      });
      throw err;
    }
  };

  return {
    validateDealSelection,
    loading,
    error,
  };
};
